import { DefaultGridDataProvider } from "../../data-grid/default-grid-data.provider";
import { ElasticSearchService } from "../../services/elastic-search.service";
import { Corpus } from "@pienso/ingest-types/corpus.interface";
import { FindReplaceService } from "./find-replace.service";
import { TransformerGridDataService } from "../transformer-grid-data.service";
import { debounceTime, filter } from "rxjs/operators";
import { TRANSFORMER_STATE } from "../abstract-transformer.service";

export class FindReplaceGridDataProvider extends DefaultGridDataProvider {
  private _corpus: Corpus | undefined;

  constructor(
    private dataService: TransformerGridDataService,
    elastic: ElasticSearchService,
    private frService: FindReplaceService,
  ) {
    super(elastic);
    frService.columnId$.subscribe((txt) => {
      if (this._corpus) {
        dataService.loadPage(0);
      }
    });
    frService.findText$
      .pipe(
        filter(() => !this.dataService.ignoreLoads), // avoid the debounce timer causing an extra load after the ignoreLoads flag is reset
        debounceTime(100),
      )
      .subscribe((txt) => {
        if (frService.columnId && this._corpus) {
          dataService.loadPage(0);
        }
      });
    frService.state$.subscribe((state) => {
      if (state !== TRANSFORMER_STATE.PENDING && this._corpus) {
        dataService.loadPage(0);
      }
    });
  }

  public set corpus(c: Corpus | undefined) {
    this._corpus = c;
  }

  protected override getResults(esIndex: string, pageSize: number, esOffset: number) {
    const findText =
      this.frService.state === TRANSFORMER_STATE.DONE ? this.frService.replaceText : this.frService.findText;
    if (findText.length > 0 && this.frService.columnId) {
      return this.elastic.partialPhraseSearch(this.frService.columnId, findText, esIndex, pageSize, esOffset);
    }
    return super.getResults(esIndex, pageSize, esOffset);
  }
}
